module.exports = __webpack_public_path__ + "static/media/lactose-free.1662f109.svg";